import axios from "axios";

const runtimeBackendUrl = typeof window !== "undefined" ? window.location.origin : "";
const rawBackendUrl = process.env.REACT_APP_BACKEND_URL || runtimeBackendUrl;
export const BACKEND_URL = rawBackendUrl.replace(/\/+$/, "");
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("resto_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fileUrl = (fileId) => (fileId ? `${API}/files/${fileId}` : "");

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

/**
 * Susun pesan error siap tampil dari response API (detail FastAPI),
 * error validasi lokal, atau fallback Bahasa Indonesia.
 */
export function apiErrorMessage(err, fallback = "Terjadi kesalahan, silakan coba lagi") {
  const detail = err?.response?.data?.detail;
  if (detail != null && detail !== "") return formatApiError(detail);
  if (err?.code === "ERR_NETWORK") return "Tidak dapat terhubung ke server. Pastikan backend berjalan.";
  if (err?.message && !err?.isAxiosError) return err.message;
  return fallback;
}

export const formatIDR = (n) =>
  new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", minimumFractionDigits: 0 }).format(n || 0);

export default api;
